import { render, staticRenderFns } from "./ButtonFavorite.vue?vue&type=template&id=09c55861"
import script from "./ButtonFavorite.vue?vue&type=script&lang=ts"
export * from "./ButtonFavorite.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports